import { render, staticRenderFns } from "./cnLayout.vue?vue&type=template&id=0aaf45a8&"
import script from "./cnLayout.vue?vue&type=script&lang=js&"
export * from "./cnLayout.vue?vue&type=script&lang=js&"
import style0 from "./cnLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports